import { SORTABLE_COLUMNS, type SortableColumn } from "../constants";

export function toApiSortColumn(column: string): string {
  if (column in SORTABLE_COLUMNS) {
    return SORTABLE_COLUMNS[column as SortableColumn];
  }

  return column.charAt(0).toUpperCase() + column.slice(1);
}

export function normalizeSortColumn(column: string | undefined): string | null {
  if (!column) return null;
  return toApiSortColumn(column);
}

export function areColumnsEqual(
  column1: string | undefined,
  column2: string | undefined
): boolean {
  const normalized1 = normalizeSortColumn(column1);
  const normalized2 = normalizeSortColumn(column2);
  return normalized1 !== null && normalized1 === normalized2;
}
